import { NON_ORGANIZATION_PATH_PREFIXES } from "@/utils/nonOrganizationPathPrefixes"

export function getRouteOrganizationSlug(asPath: string): string | null {
  const firstSegment = asPath.split("?")[0]?.split("/").filter(Boolean)[0]
  if (!firstSegment || NON_ORGANIZATION_PATH_PREFIXES.has(firstSegment)) {
    return null
  }

  return firstSegment
}

export function isTransportOrganizationSynced({
  activeOrganizationSlug,
  routeOrganizationSlug,
}: {
  activeOrganizationSlug: string | null
  routeOrganizationSlug: string | null
}) {
  return (
    routeOrganizationSlug === null ||
    (activeOrganizationSlug !== null &&
      activeOrganizationSlug === routeOrganizationSlug)
  )
}

export function isTransportRouteOrganizationActive({
  activeOrganizationId,
  activeOrganizationSlug,
  routeOrganizationId,
  routeOrganizationSlug,
}: {
  activeOrganizationId: string | null
  activeOrganizationSlug: string | null
  routeOrganizationId: string | null
  routeOrganizationSlug: string | null
}) {
  if (routeOrganizationSlug === null) {
    return true
  }

  return (
    activeOrganizationSlug === routeOrganizationSlug &&
    activeOrganizationId !== null &&
    activeOrganizationId === routeOrganizationId
  )
}
